import { render } from "./CompletedPaymentsTable.vue?vue&type=template&id=6a962163&scoped=true"
import script from "./CompletedPaymentsTable.vue?vue&type=script&lang=js"
export * from "./CompletedPaymentsTable.vue?vue&type=script&lang=js"

import "./CompletedPaymentsTable.vue?vue&type=style&index=0&id=6a962163&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sabir\\Downloads\\Subrogation-Progress\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a962163"]])

export default __exports__